import { useLocalStorage } from '~/common/use-storage';

const EVENT_FILTERS_STORAGE_KEY = 'events.filters';
const DEFAULT_FILTERS = {
  hideSnoozed: true,
};

export function useIssuesFilters() {
  return useLocalStorage(EVENT_FILTERS_STORAGE_KEY, DEFAULT_FILTERS);
}
